import { useEffect, useState } from 'react';
import { etMinutesNow } from './format.js';

// The Charleston clock in minutes past midnight, re-read every 30 seconds
// while `enabled`. Null when not, so an archived brief never marks a "now".
export function useEtMinutes(enabled = true) {
  const [minutes, setMinutes] = useState(() => (enabled ? etMinutesNow() : null));
  useEffect(() => {
    if (!enabled) {
      setMinutes(null);
      return undefined;
    }
    const tick = () => setMinutes(etMinutesNow());
    tick();
    const id = setInterval(tick, 30000);
    return () => clearInterval(id);
  }, [enabled]);
  return minutes;
}
